<ng-container *ngIf="isPlayable(); else placeholder">
  <span
    class="m-videoPlayer__notice--error"
    *ngIf="status === 'failed' && !(awaitingTranscode | async)"
  >
    There was an error transcoding this video.
  </span>
  <span
    class="m-videoPlayer__notice--created"
    *ngIf="awaitingTranscode | async"
  >
    This video is waiting to be transcoded.
  </span>
  <div class="m-videoPlayer__screen">
    <plyr
      style="display: block; width: 100%; height: 100%;"
      [plyrPoster]="service.poster$ | async"
      [plyrPlaysInline]="true"
      [plyrSources]="!service.playable ? emptySource : (sources$ | async)"
      [plyrOptions]="options"
      (plyrEnded)="onEnded($event)"
      (plyrPlay)="onPlayed($event)"
      (plyrControlsShown)="onControlsShown.next($event)"
      (plyrControlsHidden)="onControlsHidden.next($event)"
      (plyrEnterFullScreen)="fullScreenChange.next($event)"
      (plyrExitFullScreen)="fullScreenChange.next($event)"
      (plyrLoadedMetadata)="emitDimensions($event)"
      (plyrPlaying)="onPlay()"
      (plyrReady)="onReady()"
      (plyrVolumeChange)="onVolumeChange()"
      (plyrSeeking)="onSeeking()"
    >
    </plyr>
  </div>
</ng-container>

<ng-template #placeholder>
  <div
    class="m-videoPlayer__placeholder"
    [class.m-videoPlayer__placeholder--embedded]="embedded"
    [style.background-image]="'url(' + (service.poster$ | async) + ')'"
  >
    <i
      class="material-icons minds-video-play-icon"
      (click)="onPlaceholderClick($event)"
    >
      play_circle_outline
    </i>
  </div>
</ng-template>
<m-autoProgress__overlay *ngIf="isModal"> </m-autoProgress__overlay>
